<script lang="ts" setup>
import useMainStore from "~/shared/store";
import getHeaderPosition from "~/composables/get-header-position";
import Notification from "~/components/ui/notifications/Notification.vue";
import {useMonitorSize} from "~/composables/monitor-size";
import type {IMonitorSize} from "~/shared/interfaces/composables";

const mainStore = useMainStore()
let sizes: IMonitorSize | null = useMonitorSize()
const notifGroupTopIndent = ref('0px')
const transitionEffect = computed(() => sizes?.isMobile? 'slide-down' : 'slide-left')
let startY = 0
let endY = 0
let timeout: NodeJS.Timeout

watchEffect(() => {
  if(import.meta.client) {
    const headerPosition = getHeaderPosition()
    notifGroupTopIndent.value = sizes?.isMobile ? '8px' : `${(headerPosition? headerPosition.bottom : 0) + 20}px`
  }
});

watch(() => mainStore.notifications, () => {
  timeout = setTimeout(() => {
    mainStore.setNotifications(null)
  }, 5000)
})

function deleteNotif(index: number) {
  mainStore.deleteNotification(index)
  if (!mainStore.notifications?.length) {
    clearTimeout(timeout)
  }
}

function handleSwipe(event: TouchEvent) {
  if (event.type === 'touchstart') {
    startY = event.touches[0].clientY
  } else {
    endY = event.changedTouches[0].clientY
  }

  if (startY - endY > 60) {
    mainStore.setNotifications(null)
  }
}
</script>

<template>
  <div
    class="notification-group"
    @touchstart.passive="handleSwipe"
    @touchend="handleSwipe"
  >
    <TransitionGroup :name="transitionEffect">
      <Notification
        v-for="(notif, index) in mainStore.notifications"
        :key="`notif-${index}`"
        :id="index"
        :text="notif.text"
        :icon="notif.icon"
        :title="notif.title"
        @delete-notif="deleteNotif(index)"
      />
    </TransitionGroup>
  </div>
</template>

<style lang="scss" scoped>
.notification-group {
  pointer-events: none;
  position: fixed;
  top: v-bind(notifGroupTopIndent);
  width: 100%;
  left: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 100;
  align-items: flex-end;
  padding: 0 20px;
  @include xs-breakpoint {
    height: calc(100% - v-bind(notifGroupTopIndent));
  }
}
</style>
